<template>

  <div>

    <contract-list-add-new
      :is-add-new-contract-sidebar-active.sync="isAddNewContractSidebarActive"
      @refetch-data="refetchData"/>


    <!-- Table Container Card -->
    <b-card no-body class="mb-0">

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col cols="12" md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary" @click="isAddNewContractSidebarActive = true">
                <span class="text-nowrap">{{ $t('Create Contract')}}</span>
              </b-button>

            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refContractListTable"
        class="position-relative"
        :items="fetchContracts"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc">


        <!-- Column: color -->
        <template #cell(color)="data">
          <span class="badge" v-bind:style="{ 'background-color': data.item.color }">{{ data.item.color }}</span>
        </template>


        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown variant="link" class="actionIcon"
            no-caret :right="$store.state.appConfig.isRTL">

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item :to="{ name: 'contracts.edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>

<!--            <b-dropdown-item @click="removeGroup(data.item.id)">-->
<!--              <feather-icon icon="TrashIcon" />-->
<!--              <span class="align-middle ml-50">{{ $t('Delete')}}</span>-->
<!--            </b-dropdown-item>-->

          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{$t('entries')}}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalContracts"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'

import contractStoreModule from '@/views/modules/contract/store/contractStoreModule'
import ContractListAddNew from '@/views/modules/contract/contracts-list/ContractsListAddNew'
import { OrbitSpinner } from 'epic-spinners'
import useContractsList from '@/views/modules/contract/contracts-list/useContractsList'

export default {
  components: {
    ContractListAddNew,
    OrbitSpinner,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup(props, {root}) {

    const isAddNewContractSidebarActive = ref(false)

    const {

      fetchContracts,
      tableColumns,
      perPage,
      currentPage,
      totalContracts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refContractListTable,
      refetchData,
      // removeGroup,

      // UI
      requestStatus,

    } = useContractsList(root)



    return {

      // Sidebar
      isAddNewContractSidebarActive,
      requestStatus,
      fetchContracts,
      tableColumns,
      perPage,
      currentPage,
      totalContracts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refContractListTable,
      // removeGroup,
      refetchData,

    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.actionIcon > button {
  padding: 0;
}
</style>
